import axios from 'axios'

const memoURL = () => `${process.env.REACT_APP_BASEURL}/memo`;

const authHeaders = (token) => ({
  Authorization: 'Bearer ' + token
});

export const fetchMemos = (token, params) => axios({
  method: 'GET',
  url: `${memoURL()}/list`,
  params: params,
  headers: authHeaders(token),
});

export const createMemo = (token, memo) => axios({
  method: 'POST',
  url: memoURL(),
  data: memo,
  headers: authHeaders(token),
});

export const updateMemo = (token, id, memo) => axios({
  method: 'PUT',
  url: `${memoURL()}/${id}`,
  data: memo,
  headers: authHeaders(token),
});

export const deleteMemo = (token, id) => axios({
  method: 'DELETE',
  url: `${memoURL()}/${id}`,
  headers: authHeaders(token),
});

export const errorMessage = (error) => {
  if (error.response && error.response.data && error.response.data.msg) {
    return error.response.data.msg;
  }
  if (error.response) {
    return `接続エラー(${error.response.status})`;
  }
  return `エラー(${error})`;
};

export const formatDateTime = (iso) => {
  if (!iso) {
    return '';
  }
  return new Date(iso).toLocaleString('ja', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
  });
};
